import { OutlineElement } from '@phase2/outline-core';
import { html, TemplateResult, CSSResultArray } from 'lit';
import { customElement } from 'lit/decorators.js';
import { AdoptedStyleSheets } from '@phase2/outline-adopted-stylesheets-controller';

import componentStyles from './pc-basic-hero.css.lit';
import globalStyles from './pc-basic-hero.lightDom.css.lit';
import '../pc-container/pc-container';
import '../pc-animation/pc-animation';
/**
 * Basic hero component
 * @element pc-basic-hero
 * @slot - This element has a default slot
 */
@customElement('pc-basic-hero')
export class PCBasicHero extends OutlineElement {
  adoptedStylesheets: AdoptedStyleSheets;

  static styles: CSSResultArray = [componentStyles];

  hasImage = false;

  connectedCallback() {
    super.connectedCallback();
    this.adoptedStylesheets = new AdoptedStyleSheets(globalStyles);
    this.addController(this.adoptedStylesheets);
    this.hasImage = !!this.querySelector('img');
  }

  firstUpdated() {
    setTimeout(() => {
      this.setAttribute('loaded', 'loaded');
    }, 300);
  }

  render(): TemplateResult {
    return html`
      <div class="basic-hero ${!this.hasImage ? 'without-image' : ''}">
        <pc-container>
          <div class="left-side">
            <slot name="nav"></slot>
            <div class="content">
              <slot></slot>
            </div>
          </div>
          <div class="right-side">
            <slot name="image"></slot>
          </div>
        </pc-container>
        <pc-animation name="variant-3"></pc-animation>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'pc-basic-hero': PCBasicHero;
  }
}
